import React from 'react';
import CardCarousel from '../components/CardCarousel/CardCarousel.js';

const PortfolioPage = () => (
  <div>
    <h1>Portfolio</h1>
    <CardCarousel />
  </div>
);

export default PortfolioPage;
